export const REPORT_MIN_HEIGHT_PX = 250
